export default __webpack_public_path__ + "static/media/calculator-moneystack5.82046ebd.png";